import React from 'react'

function Message({message}) {
  return (
    <div style={{color:'red', textAlign:'start', padding:'0.5rem'}}>{message}</div>
  )
}

export default Message